import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { averagegain } from "../Utils/AverageGain";
import { averageloss } from "../Utils/AverageLoss";
import CandlestickFinder from "./CandlestickFinder";

var TweezerBottom =
/*#__PURE__*/
function (_CandlestickFinder) {
  _inherits(TweezerBottom, _CandlestickFinder);

  function TweezerBottom() {
    var _this;

    _classCallCheck(this, TweezerBottom);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TweezerBottom).call(this));
    _this.name = "TweezerBottom";
    _this.requiredCount = 5;
    return _this;
  }

  _createClass(TweezerBottom, [{
    key: "logic",
    value: function logic(data) {
      return this.downwardTrend(data) && data.low[3] === data.low[4];
    }
  }, {
    key: "downwardTrend",
    value: function downwardTrend(data) {
      // Analyze trends in closing prices of the first three or four candlesticks
      var gains = averagegain({
        values: data.close.slice(0, 3),
        period: 2
      });
      var losses = averageloss({
        values: data.close.slice(0, 3),
        period: 2
      }); // Downward trend, so more losses than gains

      return losses > gains;
    }
  }]);

  return TweezerBottom;
}(CandlestickFinder);

export { TweezerBottom as default };
export function tweezerbottom(data) {
  return new TweezerBottom().hasPattern(data);
}